/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Link_Or_Record_MissingInputs */

const fr_error_link_or_record_missing = /** @type {(inputs: Error_Link_Or_Record_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce lien n’est plus valide. Demandez-en un nouveau à un administrateur.`)
};

const en_error_link_or_record_missing = /** @type {(inputs: Error_Link_Or_Record_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is no longer valid. Ask an administrator for a new one.`)
};

/**
* | output |
* | --- |
* | "This link is no longer valid. Ask an administrator for a new one." |
*
* @param {Error_Link_Or_Record_MissingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_link_or_record_missing = /** @type {((inputs?: Error_Link_Or_Record_MissingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Link_Or_Record_MissingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_link_or_record_missing(inputs)
	return fr_error_link_or_record_missing(inputs)
});